import React from 'react'

import { TimeInfoStyled, TimeInfoIconStyled, TimeInfoContentStyled, TimeInfoTitleStyled, TimeInfoValueStyled } from './styles'
import { TimeInfoProps } from './types'

const TimeInfo: React.FC<TimeInfoProps> = ({ icon, title, value }) => {
  return (
    <TimeInfoStyled>
      {icon && <TimeInfoIconStyled>{icon}</TimeInfoIconStyled>}
      <TimeInfoContentStyled>
        <TimeInfoTitleStyled
          sx={{
            variant: 'bodyMontserrat23',
            fontWeight: 'bold',
            color: 'green'
          }}
        >
          {title}
        </TimeInfoTitleStyled>
        <TimeInfoValueStyled
          sx={{
            variant: 'bodyMontserrat23',
            fontWeight: '500'
          }}
        >
          {value}
        </TimeInfoValueStyled>
      </TimeInfoContentStyled>
    </TimeInfoStyled>
  )
}

export default TimeInfo
